import "./button.css"

const Button = ({text}) => {

    return(
        <div className="custom-btn">
            {text}
        </div>
    )

}

export default Button;